import React from 'react';
import PageHero from '@/app/components/PageHero';
import BackToTop from '@/app/components/BackToTop';
import RatesInfoCard from '@/app/components/RatesInfoCard';
import UnifiedConverter from '@/app/components/UnifiedConverter';

// BNB Official Fixing rates as of 01.01.2025
// Backend integration point: replace these constants with an API call to BNB's official XML feed
// https://www.bnb.bg/Statistics/StExternalSector/StExchangeRates/StERForeignCurrencies/index.htm
export const BNB_RATES = {
  EUR: {
    code: 'EUR',
    name: 'Euro',
    symbol: '€',
    flagEmoji: '🇪🇺',
    ratePerBGN: 1 / 1.95583, // 1 BGN = 0.51129... EUR
    rateToBGN: 1.95583,       // 1 EUR = 1.95583 BGN (fixed EU parity)
    color: '#003399',
    bgColor: '#eff3ff',
    borderColor: '#c7d2fe',
    note: 'Fixed EU parity rate — legally binding since Bulgaria joined the ERM II.',
  },
  USD: {
    code: 'USD',
    name: 'US Dollar',
    symbol: '$',
    flagEmoji: '🇺🇸',
    ratePerBGN: 1 / 1.85572,
    rateToBGN: 1.85572,       // 1 USD = 1.85572 BGN (BNB fixing 01.01.2025)
    color: '#166534',
    bgColor: '#f0fdf4',
    borderColor: '#bbf7d0',
    note: 'BNB official market fixing rate as published on 01.01.2025.',
  },
  BGN: {
    code: 'BGN',
    name: 'Bulgarian Lev',
    symbol: 'лв',
    flagEmoji: '🇧🇬',
    ratePerBGN: 1,
    rateToBGN: 1,
    color: '#7c3aed',
    bgColor: '#faf5ff',
    borderColor: '#ddd6fe',
    note: 'Bulgarian Lev — official currency of Bulgaria.',
  },
} as const;

export type CurrencyCode = keyof typeof BNB_RATES;

export default function CurrencyCalculatorPage() {
  return (
    <div className="space-y-10">
      <PageHero />
      <RatesInfoCard />

      {/* Unified Currency Converter */}
      <section id="converter" className="scroll-mt-20">
        <UnifiedConverter />
      </section>

      <BackToTop />
    </div>
  );
}